import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import { isEmpty } from "lodash";

import { ButtonComp, Icon } from "components";
import { getArtieLogo, getIsMaximized, removeAndAddMessages, getEnabledScheduleTour } from "slices";
import { renderMascot } from "utils";
import { sendHayleyMessage } from "utils/methods/index";

const FollowUp = ({ isLastBot, staticImageData, isUserMsg, position, mascotSettings, customSize, follow_up }) => {
  const dispatch = useDispatch();
  const artieLogo = useSelector(getArtieLogo);
  const isMaximized = useSelector(getIsMaximized);
  const enabledScheduleTour = useSelector(getEnabledScheduleTour);

  const OnSchedule = () => {
    sendHayleyMessage({
      text: "Schedule a tour",
      queryType: "question",
      ownerType: "prospect",
      kgNodeValue: "Schedule a tour",
    });

    dispatch(removeAndAddMessages([{ message: "", speaker: "faqBot", subject: "schedule a tour", type: "follow", createdAt: new Date().toISOString() }]));

    const eventHash = {
      event_name: "h_click",
      event_params: {
        h_page_type: "hayley",
        h_clicked_location: "sechedule_tour",
        h_stream: "hyly",
        h_display_method: "iframe",
      },
    };
    window.parent.postMessage(JSON.stringify(eventHash), "*");
    
    sendHayleyMessage({
      text: enabledScheduleTour ? t("almostDoneFewMoreDetail") : t("noScheduleDetailGet") || "",
      queryType: "answer",
      ownerType: "agent",
      kgNodeValue: "Schedule a tour",
    });
  };

  const handleCancel = () => {
    sendHayleyMessage({
      text: "No",
      queryType: "question",
      ownerType: "prospect",
      kgNodeValue: "Schedule a tour",
    });

    dispatch(
      removeAndAddMessages([
        { message: "No", speaker: "user", createdAt: new Date().toISOString() },
        {
          message: "howHelp",
          speaker: "bot",
          createdAt: new Date().toISOString(),
        },
      ])
    );

    sendHayleyMessage({
      text: t("howHelp") || "",
      queryType: "answer",
      ownerType: "agent",
      kgNodeValue: t("howHelp") || "",
    });
  };

  return (
    <div style={{ overflowWrap: "break-word" }}>
      <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
        {isUserMsg ? (
          isMaximized ? (
            <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
          ) : (
            ""
          )
        ) : (
          <>
            {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

            {!isEmpty(artieLogo) && (
              <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                <img
                  id="staticImage"
                  src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                  alt=""
                  className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                />
              </div>
            )}
          </>
        )}
        <div className="hayley-mx-3">
          <div className="hayley-max-w-[725px] hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
            {follow_up?.tour_not_scheduled?.text.length > 0 ? follow_up?.tour_not_scheduled?.text : t("wouldYouSchedule")}
          </div>
          <div className="hayley-mt-3 hayley-flex hayley-items-center hayley-gap-2">
            <ButtonComp filled label={t("Yes")} onClick={OnSchedule} />
            <ButtonComp label={"No"} onClick={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUp;
